import React from "react";
import { ArrowForward, Edit } from "@mui/icons-material";
import { IconButton, Grid, Stack, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { HeaderTitle } from "../../../../components/HeaderTitle";
import { useTranslate } from "../../../../hooks/useTranslate";
import { NoProperty } from "./styles";
import { useAuth } from "../../../../hooks/useAuth";
import { Map } from "../../../../components/Map";

const ListProperties = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const { translate } = useTranslate();

  const properties = auth.properties;

  return (
    <Stack spacing={3}>
      <HeaderTitle
        title={translate("property.title_list")}
        showPlus={properties.length === 0}
        urlPlus="/properties/create"
      />
      {properties.length > 0 ? (
        <>
          {properties.map((property) => (
            <Paper elevation={5} sx={{ overflow: "hidden" }} key={property.id}>
              <Grid container>
                <Grid
                  item
                  md={!property.latitude || !property.longitude ? 12 : 3}
                >
                  <Stack spacing={1} sx={{ p: 3 }}>
                    <Stack>
                      <Typography variant="caption">
                        {translate("global.placeholder_name")}
                      </Typography>
                      <strong>{property.name}</strong>
                    </Stack>
                    <Stack>
                      <Typography variant="caption">
                        {translate("property.placeholder_city")}
                      </Typography>{" "}
                      <strong>{property.city}</strong>
                    </Stack>
                    <Stack>
                      <Typography variant="caption">
                        {translate("property.placeholder_state")}
                      </Typography>{" "}
                      <strong>{property.state}</strong>
                    </Stack>
                    <Stack>
                      <Typography variant="caption">
                        {translate("property.name_veterinary")}
                      </Typography>
                      <strong>{property.nameVeterinary}</strong>
                    </Stack>
                    <Stack>
                      <Typography variant="caption">
                        {translate("property.placeholder_hectares")}
                      </Typography>
                      <strong>{property.hectares}</strong>
                    </Stack>
                    <Stack>
                      <Typography variant="caption">
                        {translate("property.placeholder_type_production")}
                      </Typography>
                      <strong>{property.typeProduction}</strong>
                    </Stack>
                    <Stack direction="row" sx={{ justifyContent: "flex-end" }}>
                      <IconButton
                        color="primary"
                        onClick={() => {
                          navigate(`/properties/edit/${property.id}`);
                        }}
                      >
                        <Edit />
                      </IconButton>
                      <IconButton
                        color="primary"
                        onClick={() => {
                          navigate(`/properties/${property.id}`);
                        }}
                      >
                        <ArrowForward />
                      </IconButton>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item md={9}>
                  {!!property.latitude && !!property.longitude && (
                    <Map
                      style={{ width: "100%", height: "100%" }}
                      coordinates={{
                        lat: property.latitude,
                        lng: property.longitude,
                      }}
                      // getPosition={}
                      scrollWheelZoom={false}
                      zoom={25}
                    />
                  )}
                </Grid>
              </Grid>
            </Paper>
          ))}
        </>
      ) : (
        <NoProperty>{translate("property.without")}</NoProperty>
      )}
    </Stack>
  );
};

export { ListProperties };
